import * as React from "react";
import { Spinner } from "reactstrap";

interface IAppProps {
  value: string;
  color: string;
  size: string;
  type: string;
}

const SpinnerModel: React.FunctionComponent<IAppProps> = (props: any) => {
  const { color, size, type } = props;
  return (
    <div className="spinner">
      <Spinner color={color} size={size} type={type}>
        {props.value}
      </Spinner>
    </div>
  );
};

export default SpinnerModel;
